/** Recovery check features - a tabbed set of tables with each feature assessed for a MPA */
<!--suppress HtmlUnknownTarget -->

<template>
    <div class="feature-tabs">
        <h5>Feature assessments</h5>
        <div class="features-buttons">
            <button v-for="f in features"
                    v-bind:id="f.feature + '_btn'"
                    v-bind:disabled="f.feature === activeTab"
                    v-on:click.prevent="activeTab = f.feature">
                {{ f.feature}}
            </button>
        </div>

        <div v-for="f in features" v-if="f.feature === activeTab">
            <p><strong>{{ f.feature }}</strong></p>
            <p><span v-if="f.feature_GMA">Feature General Management Approach (GMA): {{ f.feature_GMA }}</span></p>
            <p>
                Feature designated:
                <span v-if="f.feature_designation_date_as_text">{{ f.feature_designation_date_as_text }}</span>
                <span v-else>Unknown</span>.
                <br>
                Most recent condition/vulnerability assessment:
                <span v-if="f.assessment_date_as_text">{{ f.assessment_date_as_text }}</span>
                <span v-else>Unknown</span>.
                <br>
                Date site checked for this assessment: {{ f.date_site_checked_for_assessment }}
            </p>

            <p>
                <span v-if="f.feature_condition_or_vulnerability_assessed">Feature condition/vulnerability assessment <strong>is</strong> available on SNCB website.</span>
                <span v-else>Feature condition/vulnerability assessment <strong>is not</strong> available on SNCB website.</span>
                <br>
                <span v-if="f.feature_in_jncc_classification && f.feature_in_jncc_classification !=='N'">Feature <strong>is</strong> included in JNCCs Marine Components Classification for SAC and SPAs.</span>
                <span v-else>Feature <strong>is not</strong> included in JNCCs Marine Components Classification for SAC and SPAs.</span>
            </p>

            <p>
                Overall condition of the designated feature, where Statutory Nature Conservation Bodies report an overall result:
                <strong>
                    <span v-if="f.overall_condition_vulnerability_result">{{ f.overall_condition_vulnerability_result }}</span>
                    <span v-else>Not reported by the SNCB</span>.
                </strong>
                <span v-if="f.confidence_in_assessment">
                    <br>
                    Overall confidence in this result, as reported by SNCB: {{ f.confidence_in_assessment }}
                </span>
            </p>

            <strong>Percentage of the feature in each condition, where Statutory Nature Conservation Bodies report the condition in percentages:</strong>
            <table class="base-table">
                <tr>
                    <td>Percentage of the feature in Favourable condition</td>
                    <td>{{ f.pct_favourable_condition|prop_to_percent }}</td>
                </tr>
                <tr>
                    <td>Percentage of the feature in unfavourable recovering condition</td>
                    <td>{{ f.pct_unfavourable_or_recovering_condition|prop_to_percent }}</td>
                </tr>
                <tr>
                    <td>Percentage of the feature in unfavourable no change condition</td>
                    <td>{{ f.pct_unfavourable_no_change|prop_to_percent }}</td>
                </tr>
                <tr>
                    <td>Percentage of the feature in unfavourable declining condition</td>
                    <td>{{ f.pct_unfavourable_declining|prop_to_percent }}</td>
                </tr>
                <tr>
                    <td>Percentage of the feature in partially destroyed condition</td>
                    <td>{{ f.pct_partially_destroyed|prop_to_percent }}</td>
                </tr>
                <tr>
                    <td>Percentage of the feature in destroyed condition</td>
                    <td>{{ f.pct_destroyed|prop_to_percent }}</td>
                </tr>
                <tr>
                    <td>Percentage of the feature which has not been condition assessed</td>
                    <td>{{ f.pct_not_assessed|prop_to_percent }}</td>
                </tr>
            </table>

            <p>
                <span v-if="f.link_to_condition_assessment">
                    <a target="_blank" v-bind:href="f.link_to_condition_assessment">Link to SNCB reported condition assessment.</a>
                    <span v-if="f.link_to_GMA"><br></span>
                </span>
                <span v-if="f.link_to_GMA">
                    <a target="_blank" v-bind:href="f.link_to_GMA">Link to SNCB reported GMA.</a>
                </span>
            </p>

            <p v-if="f.notes">
                <strong>Notes</strong><br>
                {{ f.notes }}
            </p>

            <p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>
        </div>
    </div>
</template>


<script>


export default {
    name: "recovery-check-features",
    components: {},
    props: {
        features: {type: Array, required: true}
    },
    data: function () {
        return {
            activeTab: undefined
        }
    },
    methods: {

    },
    computed: {},
    watch: {
        features: function() {
            if (this.features) {
                this.activeTab = this.features[0].feature;
            } else {
                this.activeTab = undefined;
            }
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            if (this.features) {
                this.activeTab = this.features[0].feature;
            } else {
                this.activeTab = undefined;
            }
        })
    }
}
</script>


<style lang="scss">
    @import "../../styles/variables.scss";

    .feature-tabs {
        font-size: 90%;

        h5 {
            margin-bottom: 5px;
        }
    }

    .features-buttons {
        button {
            cursor: pointer;
            margin: 0 10px 5px 0;
        }
    }
</style>